import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { getOptions } from '../components/options/einnahmen';
import { data } from '../components/data/einnahmen';
import { ist } from '../components/objects/einnahmen';
import { Loader } from '../components/solar/Loader';
import { StatCard, StatCardSkeleton } from '../components/solar/StatCard';
import { ChartCardSkeleton } from '../components/solar/ChartCardSkeleton';
import { Bar } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';


class EinnahmenClass extends Component {
    componentDidMount() {
        // This method runs when the component is first added to the page
        for (var k in ist) {
            this.props.request(ist[k]);
        }
    }

    render() {
        return (
            <div>
                <h3>Einnahmenübersicht</h3>
                {renderKPIRow(this.props)}
                {renderUIGesamt(this.props)}
            </div>
        );
    }
}

/**
 * KPI-Zeile: Gesamteinahmen, Gesamtausgaben, Saldo, aktuelles Jahr
 * als StatCards über dem Chart.
 */
function renderKPIRow(props) {
    const mixedUI = props.MixedBarDiagrammEinnahmenUI || {};
    let hasData = typeof (mixedUI.Soll) !== 'undefined' && mixedUI.Soll.length > 0;

    if (!props.isLoaded || !hasData) {
        return (
            <div className="stat-cards-row">
                <StatCardSkeleton variant="energy" />
                <StatCardSkeleton />
                <StatCardSkeleton variant="progress" />
                <StatCardSkeleton />
            </div>
        );
    }

    // Summiere alle Jahreswerte
    let gesamtEinnahmen = 0;
    let gesamtAusgaben = 0;

    if (Array.isArray(mixedUI.Soll)) {
        for (let i = 0; i < mixedUI.Soll.length; i++) {
            gesamtAusgaben += Number(mixedUI.Soll[i]) || 0;
        }
    }
    if (Array.isArray(mixedUI.Ist)) {
        for (let i = 0; i < mixedUI.Ist.length; i++) {
            gesamtEinnahmen += Number(mixedUI.Ist[i]) || 0;
        }
    }

    const saldo = gesamtEinnahmen - gesamtAusgaben;
    const saldoPositiv = saldo >= 0;

    // Aktuelles Jahr ermitteln
    const jetzt = new Date();
    const aktuellesJahr = jetzt.getFullYear();
    let jahrEinnahmen = 0;
    let jahrAusgaben = 0;
    if (Array.isArray(mixedUI.Year) && Array.isArray(mixedUI.Ist)) {
        const idx = mixedUI.Year.indexOf(String(aktuellesJahr));
        if (idx >= 0) {
            jahrEinnahmen = Number(mixedUI.Ist[idx]) || 0;
            jahrAusgaben = Number(mixedUI.Soll[idx]) || 0;
        }
    }

    return (
        <div className="stat-cards-row">
            <StatCard
                value={gesamtEinnahmen}
                label="Gesamteinahmen"
                unit=" €"
                icon={<i className="bi bi-cash-stack" />}
                variant="energy"
                subLabel={Math.round(gesamtEinnahmen).toLocaleString('de-DE') + ' € gesamt'}
                description="Alle Einnahmen aus PV-Stromverkauf, Einspeisevergütung und Eigenverbrauchsgewinn seit Anlagebeginn."
            />
            <StatCard
                value={gesamtAusgaben}
                label="Gesamtausgaben"
                unit=" €"
                icon={<i className="bi bi-receipt" />}
                subLabel={Math.round(gesamtAusgaben).toLocaleString('de-DE') + ' € gesamt'}
                description="Alle Ausgaben für Strombezug aus dem Netz, Wartung, Versicherung und weitere Betriebskosten."
            />
            <StatCard
                value={saldo}
                label="Saldo"
                unit=" €"
                icon={<i className="bi bi-graph-up-arrow" />}
                variant={saldoPositiv ? 'energy' : 'consumption'}
                subLabel={(saldoPositiv ? '+' : '') + Math.round(saldo).toLocaleString('de-DE') + ' €'}
                description="Differenz zwischen Einnahmen und Ausgaben. Positiv bedeutet die Anlage hat sich bereits bezahlt."
            />
            <StatCard
                value={jahrEinnahmen - jahrAusgaben}
                label={'Saldo ' + aktuellesJahr}
                unit=" €"
                icon={<i className="bi bi-calendar-month" />}
                variant={(jahrEinnahmen - jahrAusgaben) >= 0 ? 'energy' : 'consumption'}
                subLabel={'+' + jahrEinnahmen + ' € / −' + jahrAusgaben + ' €'}
                description="Jahressaldo: Einnahmen minus Ausgaben für das laufende Jahr. Positiv = profitables Jahr."
            />
        </div>
    );
}

function renderUIGesamt(props) {
    let MixedBarDiagrammEinnahmenUI = props.MixedBarDiagrammEinnahmenUI || {}
    let hasData = typeof (MixedBarDiagrammEinnahmenUI.Soll) !== 'undefined'

    // Show skeleton while loading
    if (!props.isLoaded || !hasData) {
        return <ChartCardSkeleton />;
    }

    var einnahmen = 0;
    var ausgaben = 0;

    for (let i = 0; i < MixedBarDiagrammEinnahmenUI.Soll.length; i++) {
        ausgaben += MixedBarDiagrammEinnahmenUI.Soll[i];
    }
    for (let i = 0; i < MixedBarDiagrammEinnahmenUI.Ist.length; i++) {
        einnahmen += MixedBarDiagrammEinnahmenUI.Ist[i];
    }

    let chartData = {
        labels: MixedBarDiagrammEinnahmenUI.Year,
        datasets: [
            { ...data.datasets[0], label: data.datasets[0].label + " (" + ausgaben + " €)", data: MixedBarDiagrammEinnahmenUI.Soll },
            { ...data.datasets[1], label: data.datasets[1].label + " (" + Math.round((einnahmen) * 100) / 100 + " €)", data: MixedBarDiagrammEinnahmenUI.Ist }
        ]
    };

    return (
        <Card className="chart-card">
            <Card.Body>
                <Bar data={chartData} options={{ ...getOptions(), animation: false }} />
            </Card.Body>
        </Card>
    );
}

export default connect(
    state => state.einnahmenReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(EinnahmenClass);
